// src/App.js
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './styles/dashboard.css';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import AppRouter from './AppRouter';
import { FaHome, FaChartBar, FaMapMarkerAlt, FaUser } from 'react-icons/fa';
import { AiOutlineRise } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

function App() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);

    
    const location = useLocation();
    const navigate = useNavigate();
const [activeNav, setActiveNav] = useState(location.pathname);


    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setSidebarOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    const isLoginPage = location.pathname === '/login';
    const isTradePage = location.pathname === '/trade';

    console.log('App.js - isAuthenticated:', isAuthenticated, 'isLoginPage:', isLoginPage);

 

    return (
        <div className="dashboard-page">
            {isAuthenticated && !isLoginPage && <Navbar toggleSidebar={toggleSidebar} />}
            <div ref={sidebarRef}>
            {isAuthenticated && !isLoginPage && <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />}
            </div>
            <div className={`dashboard-container ${sidebarOpen ? 'shifted' : ''}`}>
                <div className="content-wrapper">
                    <AppRouter />
                </div>
            </div>
            {isAuthenticated && !isLoginPage && !isTradePage &&(
                <footer className="footer">
                <div className="bottom-nav">
                    <div
                        className={`nav-item ${activeNav === '/' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveNav('/');
                            navigate('/');
                        }}
                    >
                        <FaHome className="nav-icon" />
                        <span className="nav-text">Home</span>
                    </div>
                    <div
                        className={`nav-item ${activeNav === '/market' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveNav('/market');
                            navigate('/market');
                        }}
                    >
                        <FaChartBar className="nav-icon" />
                        <span className="nav-text">Market</span>
                    </div>
                    <div
                        className={`nav-item ${activeNav === '/trade' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveNav('/trade');
                            navigate('/trade');
                        }}
                    >
                        <AiOutlineRise className="nav-icon" />
                        <span className="nav-text">Trade</span>
                    </div>
                    <div
                        className={`nav-item ${activeNav === '/spot' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveNav('/spot');
                            navigate('/spot');
                        }}
                    >
                        <FaMapMarkerAlt className="nav-icon" />
                        <span className="nav-text">Spot</span>
                    </div>
                    <div
                        className={`nav-item ${activeNav === '/profile' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveNav('/profile');
                            navigate('/profile');
                        }}
                    >
                        <FaUser className="nav-icon" />
                        <span className="nav-text">Profile</span>
                    </div>
                </div>
            </footer>
            
            )}
        </div>
    );
}

export default App;